/**
 * Addresses changed on 2026-09-27: the company left the path (/w/:slug/inbox → /inbox) and the
 * Portuguese names became English. Old links, in e-mails, CRM notes or bookmarks, still land in
 * the right place: this maps them, and the company travels as ?ws= until the router opens it.
 */
const SETUP_VIEWS: Record<string, string> = {
  "boas-vindas": "welcome",
  organizacao: "organization",
  entrada: "entry",
  ensaio: "rehearsal",
  "no-ar": "live",
};

/** Settings block anchors, Portuguese → English. */
export const ANCHORS: Record<string, string> = {
  "aprovacao-de-campanha": "campaign-approval",
  avisos: "alerts",
  "chaves-api": "api-keys",
  "chaves-ia": "ai-keys",
  conectar: "connect",
  descadastro: "opt-out",
  "entrada-de-leads": "lead-intake",
  equipes: "teams",
  exportacao: "export",
  "frequencia-de-marketing": "marketing-frequency",
  lgpd: "data-subjects",
  limite: "limit",
  "limite-ia": "ai-limit",
  "metricas-de-modelos": "template-insights",
  orcamento: "budgets",
  pessoas: "people",
  "quem-pode-enviar": "who-can-send",
  retencao: "retention",
  suporte: "support",
  "uso-ia": "ai-usage",
};

const hashOf = (hash: string) => {
  const h = hash.replace(/^#/, "");
  return h ? `#${ANCHORS[h] ?? h}` : "";
};

/** The new address for an old one, or null when the address is already current. */
export function currentAddress(
  path: string,
  hash = "",
): { path: string; hash: string; slug: string | null } | null {
  const reset = /^\/nova-senha\/([^/]+)$/.exec(path);
  if (reset)
    return { path: `/reset-password/${reset[1]}`, hash: "", slug: null };
  const deletion = /^\/exclusao-de-dados\/([^/]+)$/.exec(path);
  if (deletion)
    return { path: `/data-deletion/${deletion[1]}`, hash: "", slug: null };
  if (path === "/seguranca") return { path: "/security", hash: "", slug: null };
  const w = /^\/w\/([^/]+)(\/.*)?$/.exec(path);
  if (!w) return null;
  let rest = w[2] && w[2] !== "/" ? w[2] : "/inbox";
  const setup = /^\/implantacao(?:\/([^/]+))?$/.exec(rest);
  if (setup)
    rest = setup[1] ? `/setup/${SETUP_VIEWS[setup[1]] ?? setup[1]}` : "/setup";
  return { path: rest, hash: hashOf(hash), slug: decodeURIComponent(w[1]!) };
}
